export default "__VITE_ASSET__Cpip3GIm__"